/*
 * CHI-20 <-> CHI-22 seam (composed). Dev1's eligibility rule (client/src/lib/eventCta.ts)
 * and <BuyTicketsButton> (client/src/components/BuyTicketsButton.tsx) are the ONE
 * Buy Tickets decision and the ONE Buy Tickets component. This file only adapts the
 * names Dev3's EventTicketsPanel / EventDetail already use; it holds no rule of its own.
 */
import BuyTicketsButton from "@/components/BuyTicketsButton";
import { shouldShowBuyTickets, type EventCtaEvent, type EventCtaViewer } from "@/lib/eventCta";

export const HAS_DEV1_BUY_TICKETS = true;

/** Dev1's rule, unchanged: internally paid, not ended, not special (flag off), no blocking ticket. */
export function shouldShowBuyTicketsCta(event: EventCtaEvent, viewer: EventCtaViewer): boolean {
  return shouldShowBuyTickets(event, viewer);
}

export function BuyTicketsCta({ slug }: { slug: string }) {
  return <BuyTicketsButton slug={slug} />;
}
